import { formatDistanceToNow, parseISO } from "date-fns";
import { ClockIcon } from "@icons";
import { useConversations } from "@api/agentChat.api";
import { AGENT_CHAT_SUGGESTED_PROMPTS } from "./agentChatSuggestedPrompts";
import styles from "./AgentChat.module.scss";

interface Props {
    workspaceId: string;
    onPromptSelected: (prompt: string) => void;
    onHistorySelected: (conversationId: string) => void;
}

export const AgentChatSuggestionsPopover: React.FC<Props> = ({
    workspaceId,
    onPromptSelected,
    onHistorySelected,
}) => {
    const conversations = useConversations({ workspaceId, limit: 10 });
    const recent =
        conversations.data?.pages.flatMap((page) => page.conversations) ?? [];

    return (
        <div className={styles.popover}>
            <header className={styles.popoverHeader}>
                <h3>Suggested prompts</h3>
            </header>

            <section className={styles.suggestionsSection}>
                {AGENT_CHAT_SUGGESTED_PROMPTS.map((suggestion) => (
                    <button
                        key={suggestion.label}
                        type="button"
                        className={styles.suggestionRow}
                        onClick={() => onPromptSelected(suggestion.prompt)}
                    >
                        <span className={styles.suggestionIcon}>
                            {suggestion.icon}
                        </span>
                        <span>{suggestion.prompt}</span>
                    </button>
                ))}
            </section>

            {recent.length > 0 && (
                <section className={styles.historySection}>
                    <h4>Recent conversations</h4>
                    {recent.map((c) => (
                        <button
                            key={c.id}
                            type="button"
                            className={styles.historyRow}
                            onClick={() => onHistorySelected(c.id)}
                        >
                            <span className={styles.historyIcon}>
                                <ClockIcon />
                            </span>
                            <span className={styles.historyTitle}>
                                {c.title}
                            </span>
                            <span className={styles.historyDate}>
                                {formatDistanceToNow(parseISO(c.updatedAt), {
                                    addSuffix: true,
                                })}
                            </span>
                        </button>
                    ))}
                    {conversations.hasNextPage && (
                        <button
                            type="button"
                            className={styles.loadMoreRow}
                            onClick={() => conversations.fetchNextPage()}
                            disabled={conversations.isFetchingNextPage}
                        >
                            {conversations.isFetchingNextPage
                                ? "Loading…"
                                : "Show more"}
                        </button>
                    )}
                </section>
            )}
        </div>
    );
};
